import {Logger} from "./logger";
import ShopPromoLarge from "./large/shoppromo_large";
import {otto} from "@otto-ec/global-resources/nexus";
import ShopPromoSmall from "./small/shoppromo_small";
import PromoBrandShopPromo from "./brand/promo_brandshoppromo";
import BrandhubDiscoveryCard from "./brandhub/discovery_card";


otto.ft3.promo.shoppromo.assignNamespace({
    shoppromo_large: {
        init: initShoppromoLarge
    },
    shoppromo_small: {
        init: initShoppromoSmall
    },
    brandshop_promo: {
        init: initBrandshoppromo
    },
    brandhub_discovery_card: {
        init: initBrandhubDiscoveryCard
    }
})

function initShoppromoLarge(promoType: string, featureId: number): void {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Large Shoppromo Invocation");
    const container = document.querySelector(`[data-promo-type="${promoType}"][data-feature-id="${featureId}"].promo_shoppromo-large--container`)!;
    new ShopPromoLarge(container);
    Logger.groupEnd();
}

function initShoppromoSmall(featureId: number): void {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Small Shoppromo Invocation");
    const container = document.querySelector(`[data-feature-id="${featureId}"].promo_shoppromo-small--container`)!;
    new ShopPromoSmall(container);
    Logger.groupEnd();
}

function initBrandshoppromo(featureId: number): void {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Brandshoppromo Invocation");
    const container = document.querySelector(`[data-feature-id="${featureId}"].promo_brandshoppromo--container`)!;
    new PromoBrandShopPromo(container);
    Logger.groupEnd();
}

function initBrandhubDiscoveryCard(featureId: number): void {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Brandhub Discovery Card Invocation");
    const container = document.querySelector(`[data-feature-id="${featureId}"].promo_brandhub_discovery_card__container`)!;
    new BrandhubDiscoveryCard(container);
    Logger.groupEnd();
}